<template>
  <toggle-button
    class="status--toggle"
    v-model="status"
    @change="handleStatusChange"
    :labels="{ checked: 'Ativo', unchecked: 'Inativo' }"
    :height="25"
    :width="85"
    :font-size="14"
  />
</template>

<script>
import { mapMutations } from 'vuex'
import VueCookies from 'vue-cookies'

export default {
  name: 'StatusToggle',
  props: {
    item: {
      type: Object,
      required: true
    },
    itemStatus: {
      type: Boolean,
      required: true,
      default: false
    },
    itemType: {
      type: String,
      required: true
    },
    updateAction: {
      type: Function,
      required: true
    },
    disableAction: {
      type: Function,
      required: true
    },
  },
  data () {
    return {
      status: false,
    }
  },
  created () {
    this.status = this.itemStatus
  },
  methods: {
    ...mapMutations({
      setToaster: 'Shared/SET_TOASTER'
    }),
    async handleStatusChange () {
      const token = VueCookies.get('jwt-login')

      if (this.status) {
        await this.update(token)
      } else {
        await this.disable(token)
      }
    },
    async update (token) {
      try {
        const response = await this.updateAction([
          {
          ...this.item,
          [this.itemType]: true
          },
          token
        ])

        if (response.status >= 400) {
          throw new Error(response.data.message)
        } else {
          this.toaster(
            'Status atualizado com sucesso',
            'var(--green)',
            true
          )
        }
      } catch (e) {
        this.toaster('Error', 'red accent-2', true)
      }
    },
    async disable(token) {
      try {
        const response = this.disableAction([
          this.item,
          token
        ])
        if (response.status >= 400) {
          throw new Error(response.data.message)
        } else {
          this.toaster(
            'Status atualizado com sucesso',
            'var(--green)',
            true
          )
        }
      } catch (e) {
        this.toaster('Error', 'red accent-2', true)
      }
    },
    toaster(message, color, visible) {
      this.setToaster({
        message,
        color,
        visible
      })
    },
  },
}
</script>

<style lang="scss">
.status--toggle {
  width: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/StatusToggle.vue